import { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/lib/theme";
import { CurrencyProvider } from "@/lib/currency";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ProductFamily from "@/pages/ProductFamily";
import Brands from "@/pages/Brands";
import ExportAfrica from "@/pages/ExportAfrica";
import Distributor from "@/pages/Distributor";
import Sustainability from "@/pages/Sustainability";
import Quality from "@/pages/Quality";
import News from "@/pages/News";
import Careers from "@/pages/Careers";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Portal from "@/pages/Portal";
import Downloads from "@/pages/Downloads";
import Admin from "@/pages/Admin";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import PushSubscribeCard from "@/components/PushSubscribeCard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <CurrencyProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/brands" element={<Brands />} />
                <Route path="/brands/:slug" element={<ProductFamily />} />
                <Route path="/export-africa" element={<ExportAfrica />} />
                <Route path="/distributor" element={<Distributor />} />
                <Route path="/sustainability" element={<Sustainability />} />
                <Route path="/quality" element={<Quality />} />
                <Route path="/news" element={<News />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/investors" element={<Investors />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/portal/:type" element={<Portal />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </Layout>
            <PwaInstallPrompt />
            <PushSubscribeCard />
          </BrowserRouter>
        </div>
      </CurrencyProvider>
    </ThemeProvider>
  );
}

export default App;
